import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

// الصفحات التي لا نريد فيها المؤثرات البصرية
const PUBLIC_PAGES = ['/', '/login', '/oath', '/forgot-password', '/reset-password', '/terms', '/privacy'];

// صوت البومة الحقيقي - Great Horned Owl
function playOwlSound() {
  try {
    // لا تشغّل الصوت إذا كان التطبيق في الخلفية أو الشاشة مغلقة
    if (typeof document !== 'undefined') {
      if (document.hidden) return;
      if (typeof document.hasFocus === 'function' && !document.hasFocus()) return;
    }

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    const playHoot = (startTime, baseFreq, duration) => {
      // Oscillator للنغمة الأساسية
      const osc1 = audioContext.createOscillator();
      const osc2 = audioContext.createOscillator();
      const osc3 = audioContext.createOscillator();
      
      // Gain nodes
      const mainGain = audioContext.createGain();
      const subGain = audioContext.createGain();
      
      // Filter للصوت الطبيعي
      const filter = audioContext.createBiquadFilter();
      filter.type = 'lowpass';
      filter.frequency.setValueAtTime(300, startTime);
      filter.Q.setValueAtTime(1, startTime);
      
      // ربط السلسلة
      osc1.connect(mainGain);
      osc2.connect(mainGain);
      osc3.connect(subGain);
      mainGain.connect(filter);
      subGain.connect(filter);
      filter.connect(audioContext.destination);
      
      // النغمة الأساسية - صوت عميق
      osc1.type = 'sine';
      osc1.frequency.setValueAtTime(baseFreq, startTime);
      osc1.frequency.linearRampToValueAtTime(baseFreq * 0.9, startTime + duration * 0.3);
      osc1.frequency.linearRampToValueAtTime(baseFreq * 0.75, startTime + duration);
      
      // Harmonic ثاني
      osc2.type = 'sine';
      osc2.frequency.setValueAtTime(baseFreq * 2, startTime);
      osc2.frequency.linearRampToValueAtTime(baseFreq * 1.8, startTime + duration);
      
      // Sub-bass
      osc3.type = 'sine';
      osc3.frequency.setValueAtTime(baseFreq * 0.5, startTime);
      
      // Envelope طبيعي
      mainGain.gain.setValueAtTime(0, startTime);
      mainGain.gain.linearRampToValueAtTime(0.15, startTime + 0.08);
      mainGain.gain.setValueAtTime(0.12, startTime + duration * 0.4);
      mainGain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
      
      subGain.gain.setValueAtTime(0, startTime);
      subGain.gain.linearRampToValueAtTime(0.08, startTime + 0.05);
      subGain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
      
      osc1.start(startTime);
      osc1.stop(startTime + duration);
      osc2.start(startTime);
      osc2.stop(startTime + duration);
      osc3.start(startTime);
      osc3.stop(startTime + duration);
    };
    
    // "هوو... هوو هوو" - نمط البومة الكبيرة
    const now = audioContext.currentTime;
    playHoot(now, 200, 0.6);           // هوو طويل
    playHoot(now + 0.9, 180, 0.35);    // هوو قصير
    playHoot(now + 1.35, 160, 0.4);    // هوو منخفض
    
  } catch (e) {
    console.log('Audio not supported');
  }
}

// صوت تغريد العصافير الجميل
function playBirdChirp() {
  try {
    // لا تشغّل الصوت إذا كان التطبيق في الخلفية أو الشاشة مغلقة
    if (typeof document !== 'undefined') {
      if (document.hidden) return;
      if (typeof document.hasFocus === 'function' && !document.hasFocus()) return;
    }

    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    
    const playNote = (startTime, freq, duration) => {
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      
      osc.connect(gain);
      gain.connect(audioContext.destination);
      
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, startTime);
      osc.frequency.exponentialRampToValueAtTime(freq * 1.3, startTime + duration * 0.3);
      osc.frequency.exponentialRampToValueAtTime(freq * 0.9, startTime + duration);
      
      gain.gain.setValueAtTime(0, startTime);
      gain.gain.linearRampToValueAtTime(0.08, startTime + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, startTime + duration);
      
      osc.start(startTime);
      osc.stop(startTime + duration);
    };
    
    const now = audioContext.currentTime;
    playNote(now, 2200, 0.12);
    playNote(now + 0.15, 2600, 0.1);
    playNote(now + 0.28, 2400, 0.15);
    playNote(now + 0.5, 2800, 0.08);
    
  } catch (e) {
    console.log('Audio not supported');
  }
}

// ==================== أجواء ليلية هادئة (بدلاً من البومة) ====================
export function NightAmbiance() {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, pointerEvents: 'none', zIndex: 0, overflow: 'hidden' }}>
      {/* نجوم صغيرة متلألئة */}
      {Array.from({ length: 25 }, (_, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: `${Math.random() * 3 + 1}px`,
            height: `${Math.random() * 3 + 1}px`,
            background: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `twinkle ${Math.random() * 3 + 2}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 3}s`
          }}
        />
      ))}
      <style>{`
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}

// ==================== طيور الحب ====================
export function LoveBirds() {
  const [birds, setBirds] = useState([]);

  const createBirdPair = useCallback(() => {
    const id = Date.now();
    const startY = Math.random() * 40 + 10;
    const birdType = Math.floor(Math.random() * 3);
    
    setBirds(prev => [...prev, { id, startY, birdType }]);
    
    setTimeout(() => playBirdChirp(), 800);
    
    setTimeout(() => {
      setBirds(prev => prev.filter(b => b.id !== id));
    }, 7000);
  }, []);

  useEffect(() => {
    const firstTimeout = setTimeout(() => {
      createBirdPair();
    }, 15000);

    const interval = setInterval(() => {
      createBirdPair();
    }, 90000);

    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  }, [createBirdPair]);

  const getBirdColor = (type) => {
    const colors = [
      { primary: '#FF6B9D', secondary: '#FF8FB1', accent: '#FFB6C1' },
      { primary: '#87CEEB', secondary: '#ADD8E6', accent: '#E0F7FA' },
      { primary: '#98D8AA', secondary: '#B5E8C3', accent: '#E8F5E9' }
    ];
    return colors[type];
  };

  return (
    <>
      {birds.map(bird => {
        const colors = getBirdColor(bird.birdType);
        return (
          <div
            key={bird.id}
            className="love-birds-pair"
            style={{ top: `${bird.startY}%` }}
          >
            {/* الطائر الأول */}
            <svg className="bird bird-1" width="50" height="40" viewBox="0 0 80 60">
              <ellipse cx="40" cy="35" rx="22" ry="18" fill={colors.primary} />
              <circle cx="50" cy="28" r="12" fill={colors.primary} />
              <circle cx="54" cy="26" r="4" fill="#1a1a1a" />
              <circle cx="55" cy="25" r="1.5" fill="white" />
              <path d="M62,28 L72,26 L62,30 Z" fill="#FFA500" />
              <ellipse cx="30" cy="38" rx="15" ry="10" fill={colors.secondary} />
              <path d="M18,30 Q10,35 15,45 L28,42 Z" fill={colors.primary} className="wing-1" />
              <path d="M35,50 L30,58 L40,58 L45,50" fill={colors.accent} />
            </svg>
            
            {/* الطائر الثاني */}
            <svg className="bird bird-2" width="50" height="40" viewBox="0 0 80 60">
              <ellipse cx="40" cy="35" rx="22" ry="18" fill={colors.primary} />
              <circle cx="50" cy="28" r="12" fill={colors.primary} />
              <circle cx="54" cy="26" r="4" fill="#1a1a1a" />
              <circle cx="55" cy="25" r="1.5" fill="white" />
              <path d="M62,28 L72,26 L62,30 Z" fill="#FFA500" />
              <ellipse cx="30" cy="38" rx="15" ry="10" fill={colors.secondary} />
              <path d="M18,30 Q10,35 15,45 L28,42 Z" fill={colors.primary} className="wing-2" />
              <path d="M35,50 L30,58 L40,58 L45,50" fill={colors.accent} />
            </svg>
            
            {/* قلوب صغيرة */}
            <div className="hearts">
              <span>💕</span>
              <span>💗</span>
            </div>
          </div>
        );
      })}
      
      <style>{`
        .love-birds-pair {
          position: fixed;
          z-index: 9998;
          pointer-events: none;
          animation: birdsFloat 7s ease-in-out forwards;
          right: -120px;
          display: flex;
          gap: 5px;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
        }
        
        .bird {
          animation: birdBob 0.5s ease-in-out infinite;
          transform: scaleX(-1);
        }
        
        .bird-2 {
          animation-delay: 0.25s;
          margin-top: 10px;
        }
        
        .wing-1, .wing-2 {
          animation: wingFlap 0.15s ease-in-out infinite;
          transform-origin: 28px 38px;
        }
        
        .wing-2 {
          animation-delay: 0.075s;
        }
        
        .hearts {
          position: absolute;
          top: -10px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          font-size: 12px;
        }
        
        .hearts span {
          animation: heartFloat 1s ease-in-out infinite;
        }
        
        .hearts span:nth-child(2) {
          animation-delay: 0.5s;
        }
        
        @keyframes birdsFloat {
          0% { right: -120px; transform: translateY(0); }
          20% { transform: translateY(-25px); }
          40% { transform: translateY(15px); }
          60% { transform: translateY(-10px); }
          80% { transform: translateY(20px); }
          100% { right: 110%; transform: translateY(0); }
        }
        
        @keyframes birdBob {
          0%, 100% { transform: scaleX(-1) translateY(0) rotate(-2deg); }
          50% { transform: scaleX(-1) translateY(-5px) rotate(2deg); }
        }
        
        @keyframes wingFlap {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(-30deg); }
        }
        
        @keyframes heartFloat {
          0%, 100% { transform: translateY(0) scale(1); opacity: 0.7; }
          50% { transform: translateY(-8px) scale(1.2); opacity: 1; }
        }
      `}</style>
    </>
  );
}

// ==================== تأثير القلوب عند الإعجاب ====================
export function HeartBurst({ x, y, onComplete }) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 1500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div style={{
      position: 'fixed',
      left: x - 30,
      top: y - 30,
      pointerEvents: 'none',
      zIndex: 10000
    }}>
      {[...Array(8)].map((_, i) => (
        <span
          key={i}
          style={{
            position: 'absolute',
            fontSize: `${16 + Math.random() * 10}px`,
            animation: `heartExplode 1.5s ease-out forwards`,
            animationDelay: `${i * 0.05}s`,
            transform: `rotate(${i * 45}deg) translateY(-20px)`
          }}
        >
          {['❤️', '💖', '💕', '💗'][i % 4]}
        </span>
      ))}
      <style>{`
        @keyframes heartExplode {
          0% { opacity: 1; transform: rotate(var(--rot)) translateY(0) scale(0.5); }
          50% { opacity: 1; transform: rotate(var(--rot)) translateY(-50px) scale(1.2); }
          100% { opacity: 0; transform: rotate(var(--rot)) translateY(-80px) scale(0.8); }
        }
      `}</style>
    </div>
  );
}

// ==================== تأثير الكونفيتي ====================
export function Confetti({ onComplete }) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 3000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  const colors = ['#FF6B9D', '#FEC163', '#C06EED', '#00D9A5', '#87CEEB', '#FFD700'];
  
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 10000,
      overflow: 'hidden'
    }}>
      {[...Array(50)].map((_, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            left: `${Math.random() * 100}%`,
            top: '-20px',
            width: `${8 + Math.random() * 8}px`,
            height: `${8 + Math.random() * 8}px`,
            background: colors[Math.floor(Math.random() * colors.length)],
            borderRadius: Math.random() > 0.5 ? '50%' : '2px',
            animation: `confettiFall ${2 + Math.random() * 2}s ease-out forwards`,
            animationDelay: `${Math.random() * 0.5}s`,
            transform: `rotate(${Math.random() * 360}deg)`
          }}
        />
      ))}
      <style>{`
        @keyframes confettiFall {
          0% { transform: translateY(0) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
}

// ==================== قلوب طائرة ====================
export function FloatingHearts({ trigger, onComplete }) {
  const [hearts, setHearts] = useState([]);

  useEffect(() => {
    if (trigger) {
      const newHearts = [...Array(12)].map((_, i) => ({
        id: Date.now() + i,
        left: Math.random() * 100,
        delay: Math.random() * 0.5,
        size: 16 + Math.random() * 16,
        duration: 2 + Math.random() * 2
      }));
      setHearts(newHearts);
      
      setTimeout(() => {
        setHearts([]);
        onComplete && onComplete();
      }, 4000);
    }
  }, [trigger, onComplete]);

  if (!trigger || hearts.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 10000,
      overflow: 'hidden'
    }}>
      {hearts.map(heart => (
        <span
          key={heart.id}
          style={{
            position: 'absolute',
            left: `${heart.left}%`,
            bottom: '-30px',
            fontSize: `${heart.size}px`,
            animation: `floatUp ${heart.duration}s ease-out forwards`,
            animationDelay: `${heart.delay}s`
          }}
        >
          {['❤️', '💕', '💖', '💗', '💓'][Math.floor(Math.random() * 5)]}
        </span>
      ))}
      <style>{`
        @keyframes floatUp {
          0% { transform: translateY(0) scale(0.5); opacity: 0; }
          10% { opacity: 1; transform: translateY(-10vh) scale(1); }
          90% { opacity: 1; }
          100% { transform: translateY(-100vh) scale(0.8); opacity: 0; }
        }
      `}</style>
    </div>
  );
}

// ==================== نجوم متلألئة ====================
export function SparkleStars({ trigger, onComplete }) {
  const [stars, setStars] = useState([]);

  useEffect(() => {
    if (trigger) {
      const newStars = [...Array(20)].map((_, i) => ({
        id: Date.now() + i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        delay: Math.random() * 0.8,
        size: 12 + Math.random() * 20
      }));
      setStars(newStars);
      
      setTimeout(() => {
        setStars([]);
        onComplete && onComplete();
      }, 3000);
    }
  }, [trigger, onComplete]);

  if (!trigger || stars.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: 10000
    }}>
      {stars.map(star => (
        <span
          key={star.id}
          style={{
            position: 'absolute',
            left: `${star.left}%`,
            top: `${star.top}%`,
            fontSize: `${star.size}px`,
            animation: `sparkle 1s ease-out forwards`,
            animationDelay: `${star.delay}s`
          }}
        >
          {['✨', '⭐', '🌟', '💫'][Math.floor(Math.random() * 4)]}
        </span>
      ))}
      <style>{`
        @keyframes sparkle {
          0% { transform: scale(0) rotate(0deg); opacity: 0; }
          50% { transform: scale(1.5) rotate(180deg); opacity: 1; }
          100% { transform: scale(0) rotate(360deg); opacity: 0; }
        }
      `}</style>
    </div>
  );
}

// ==================== المكون الرئيسي ====================
export default function VisualEffects() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isPageVisible, setIsPageVisible] = useState(true);
  const location = useLocation();
  
  const isPublicPage = PUBLIC_PAGES.includes(location.pathname);
  
  // متابعة تغيّر الثيم (نهاري/ليلي)
  useEffect(() => {
    if (isPublicPage) {
      document.documentElement.removeAttribute('data-theme');
      setIsDarkMode(false);
      return;
    }
    
    const checkTheme = () => {
      const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      setIsDarkMode(isDark);
    };
    
    checkTheme();
    
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    
    return () => observer.disconnect();
  }, [isPublicPage, location.pathname]);

  // إيقاف المؤثرات والصوت عند إغلاق/إخفاء التطبيق أو الانتقال للتطبيقات الأخرى
  useEffect(() => {
    const handleVisibility = () => {
      const visible = !document.hidden;
      setIsPageVisible(visible);
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('pagehide', handleVisibility);
    window.addEventListener('blur', handleVisibility);

    // تشغيل أولي
    handleVisibility();

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('pagehide', handleVisibility);
      window.removeEventListener('blur', handleVisibility);
    };
  }, []);
  
  if (isPublicPage || !isPageVisible) {
    return null;
  }
  
  return isDarkMode ? <NightAmbiance /> : <LoveBirds />;
}
